<template>
<div>
  <!-- <v-row>
    <v-col cols="12">
      <h1>國內外參賽及移訓核銷項目</h1>
    </v-col>
  </v-row> -->
  <VCard>
    <VCardText>
      <v-row>
        <v-col cols="6" md="3">
          <v-select v-model="reimbursementItem" 
          :items="reimbursementItems" 
          label="核銷項目"
          clearable
          item-title="label"
          item-value="value"
          ></v-select>
        </v-col>
        <v-col cols="6" md="3">
          <v-select v-model="location" 
          :items="locations" 
          item-title="key"
          item-value="value"
          label="地區"
          clearable
          ></v-select>
        </v-col>
        <v-col cols="12" md="6" class="d-flex justify-end">
          <v-btn color="primary" variant="tonal"
          prepend-icon="tabler-plus" @click="openDialog(dialogAllStatus[0].value)">新增</v-btn>
          <v-btn color="warning" variant="tonal"
          prepend-icon="tabler-edit"  @click="openDialog(dialogAllStatus[1].value)" class="ml-3"
          :disabled="selectTable.length>1||selectTable.length<1"
          >修改</v-btn>
          <v-btn color="error" variant="tonal"
          :disabled="selectTable.length<1"
          prepend-icon="tabler-trash" @click="deleteItem" class="ml-3">刪除</v-btn>
        </v-col>
      </v-row>
    </VCardText>
    <VDataTableServer
      v-model:items-per-page="size"
      v-model:page="page"
      :items-length="totalData"
      item-value="prikey"
      v-model="selectTable"
      :headers="headers" 
      :items="tableItems" 
      show-select
      class="text-no-wrap border-t-sm rounded-0"
      no-data-text="尚無資料"
    >
      <template #item.location="{ item }">
        {{item.location==locations[0].value?locations[0].key:locations[1].key}}
      </template>
      <template #item.fieldA="{ item }">
        {{getAthletelevelTypeName(item.fieldA)}}
      </template>
      <template #item.reimbursementItem="{ item }">
        {{getReimbursementItemName(item.reimbursementItem)}}
      </template>
      <!-- <template #item.checkbox="{ item }">
        <v-checkbox v-model="item.selected"></v-checkbox>
      </template> -->
      <template #item.judgeLower="{ item }">
        {{ formatAmount(item.judgeLower) }}
      </template>
      <template #item.judgeUpper="{ item }">
        {{ formatAmount(item.judgeUpper) }}
      </template>
      <template #item.amountLimit="{ item }">
        {{getAmountLimit(item)}}
      </template>
      <template #bottom>
        <TablePagination
          v-model:page="page"
          v-model:size="size"
          :items-per-page="size"
          :total-items="totalData"
        />
      </template>
    </VDataTableServer>
  </VCard>

  <v-dialog v-model="dialog" max-width="600px">
    <v-card>
      <v-card-title>
        <span class="headline">{{ dialogTitle }}
          <v-tooltip
          v-model="showTooltip"
          location="top"
          >
            <template v-slot:activator="{ props }">
              <v-btn
                icon
                v-bind="props"
                variant="plain"
              >
                <v-icon color="grey-lighten-1">
                  tabler-info-circle
                </v-icon>
              </v-btn>
            </template>
            <span>
              <div>
                <v-table theme="dark" style="background:transparent">
                  <thead>
                    <tr>
                      <th class="text-left">
                        分類
                      </th>
                      <th class="text-left">
                        分類-金額起
                      </th>
                      <th class="text-left">
                        分類-金額起
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr
                      v-for="item in illustrates"
                      :key="item.name"
                    >
                      <td>{{ item.name }}</td>
                      <td>{{ item.lower }}</td>
                      <td>{{ item.upper }}</td>
                    </tr>
                  </tbody>
                </v-table>
                
              </div>
            </span>
          </v-tooltip>
        </span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form ref="formRef">
            <v-radio-group v-model="form.fieldA" inline class="mb-2">
              <v-radio
                v-for="athletelevel in athletelevelType"
                :key="athletelevel.value"
                :label="athletelevel.label"
                :value="athletelevel.value"
              ></v-radio>
              <v-radio
                label="一般經費申請"
                value="X"
              ></v-radio>
            </v-radio-group>
            <v-row>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="form.location"
                  :items="locations" 
                  item-title="key"
                  item-value="value"
                  label="地區"
                  required
                  clearable
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
              <v-col cols="12" sm="6">
                <v-select
                  v-model="form.reimbursementItem"
                  :items="reimbursementItems"
                  item-title="label"
                  item-value="value"
                  label="核銷項目"
                  required
                  clearable
                  :rules="[rules.required]"
                ></v-select>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.categoryRemark"
                  label="項目分類"
                  required
                  clearable
                  hint="如有金額上限 請輸入項目分類及說明 例如:早餐-日支數額USD$300以上地區"
                ></v-text-field>
              </v-col>
              
              
              <v-radio-group v-model="selectedOption" inline>
                <v-col cols="auto" sm="1">
                  <v-radio
                    label=""
                    :value="costOption[0].value"
                  ></v-radio>
                    <!-- @change="onRadioChange('Y')" -->
                </v-col>
                <v-col cols="auto" sm="3">
                  <AmountTextField
                    v-model="form.amountLimit"
                    :label="costOption[0].key"
                    :disabled="selectedOption !== costOption[0].value"
                    clearable
                    :rules="selectedOption === costOption[1].value ? [rules.required] : []"
                  />
                </v-col>
                <v-col cols="auto" sm="4" v-for="costOptionItem in costOption.length-1" :key="costOptionItem.value">
                  <v-radio
                    :label="costOption[costOptionItem].key"
                    :value="costOption[costOptionItem].value"
                  ></v-radio>
                    <!-- @change="onRadioChange('N')" -->
                </v-col>
              </v-radio-group>
              <v-col cols="6" v-if="selectedOption==costOption[0].value">
                <AmountTextField
                  v-model="form.amountStart"
                  label="分類-金額起(美金)≤"
                  required
                  clearable
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="6" v-if="selectedOption==costOption[0].value">
                <AmountTextField
                  v-model="form.amountEnd"
                  label="分類-金額末(美金)≥"
                  required
                  clearable
                  :rules="[rules.required]"
                />
              </v-col>
              <v-col cols="12" v-if="selectedOption==costOption[2].value">
                <v-text-field
                  v-model="form.fieldB"
                  :label="costOption[2].key"
                  type="number"
                  :decimal-places="2"
                  required
                  :rules="[rules.validateTwoDecimalPlaces]"
                  :step="0.01"
                  :min="0"
                  :max="100"
                  hint="僅小數點後兩位 例:0.75"
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="form.remark"
                  label="備註"
                  required
                ></v-text-field>
              </v-col>
            </v-row>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="blue darken-1" text @click="closeDialog">取消</v-btn>
        <v-btn color="blue darken-1" text @click="saveBtn">確認</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script setup lang="ts">
import { computed, onMounted, ref } from "vue"

definePage({
  meta: {
      action: 'manage', //固定為 manage
      subject: 'REIMBURSEITEM', //系統代碼(系統授權設定中的系統代碼)
  },
})
const showTooltip = ref(false)
const illustrates = [
  {name:'未滿200',lower:'0 ≤' , upper:'≤ 199'},
  {name:'200以上未達300',lower:'200 ≤' , upper:'≤ 299'},
  {name:'300以上',lower:'300 ≤' , upper:'≤ 999999'},
]
const search = ref('')
const reimbursementItem = ref(null)
const location=ref(null)
// const reimbursementItems=reactive(['交通費', '膳宿費'])
const costOption=[
  {key:'金額上限(台幣)' , value:'L'},
  {key:'覈實報支' , value:'V'},
  {key:'日支數額比例' , value:'P'},
]
const locations =[
  { key:'國內', value:'D', }, 
  { key:'國外', value:'F', }, 
]
const dialogAllStatus=[
  { key:'新增', value:'add', },
  { key:'修改', value:'edit',},
]
const selectTable = ref([])
const page = ref(1)
const size = ref(10)
const totalData = ref(0)
const headers=reactive([
  { title: '', key: 'checkbox', sortable: false },
  { title: '地點', key: 'location' },
  { title: '級別分類', key: 'fieldA' },
  { title: '核銷項目', key: 'reimbursementItem' },
  { title: '項目分類', key: 'category' },
  { title: '分類金額起(美金)≤', key: 'judgeLower' },
  { title: '分類金額末(美金)≥', key: 'judgeUpper' },
  { title: '金額上限(台幣)', key: 'amountLimit' },
  { title: costOption[2].key, key: 'fieldB' },
  { title: '備註', key: 'remarks' },
])
const tableItems =reactive([])
const dialogStatus = ref(dialogAllStatus[0].value)
const dialog=ref(false)
const dialogTitle=ref('')
// const dialogCategory=ref('')
const selectedOption=ref(costOption[0].value)
const formRef=ref(null)


// 表單驗證規則
const rules = ref({
  required: (value) => (value !== undefined && value !== null && value !== '') || "此欄位為必填項目",
  validateTwoDecimalPlaces: (value) => {
    if (value !== '' && !isNaN(value)) {
      if(value.includes('.')){
        const parts = value.toString().split('.');
        if (parts[1].length && parts[1].length > 2) {
          return '小數點後最多兩位';
        }
      }
    }else{
      return '請輸入數字 例:0.75';
    }
    return true;
  },
});
const form =reactive({
  prikey:'',
  location:null,
  reimbursementItem:null,
  amountStart:"",
  amountEnd:"",
  categoryRemark:'',
  amountLimit:0,
  remark:'',
  fieldA:'X',     //選手級別
  fieldB:'0.00',  //日支數額比例
})

const popSwal = (icon,title,text) => {
  if(icon=="success"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else if (icon=="error"){
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }else{
    $swal({
      position: 'top-end',
      icon: icon,
      title: title,
      text: text,
      showConfirmButton: false,
      // timer: 1500,
      customClass: {
        confirmButton: 'btn btn-primary',
      },
      buttonsStyling: false,
    });
  }
}


const getAmountLimit = (value) => {
  const item = costOption.findIndex((it) => it.value == value.paymentMethod)
  if(costOption[item].value=="L"){
    return formatAmount(value.amountLimit)
  }else{
    return costOption[item].key
  }
};
// API---------------------
// 查詢核銷項目_簡易公用表格  Reimbursement
const { data: getReimbursementItems, execute: fetchReimbursementItem } = await useApi<any>(createUrl('/q/de/select/select/select/deSelect', {
  query: {
    tabId: 'Reimbursement',
  },
}))
const reimbursementItems = computed(()=>getReimbursementItems.value)

// 查詢選手級別_簡易公用表格  Reimbursement
const { data: getATHLETELEVEL, execute: fetchATHLETELEVEL } = await useApi<any>(createUrl('/q/de/select/select/select/deSelect', {
  query: {
    tabId: 'ATHLETELEVEL',
  },
}))
const athletelevelType = computed(()=>getATHLETELEVEL.value)

const getAthletelevelTypeName = (item) =>{
  if(item=="X"){
    return "一般"
  }else{
    let itemName = athletelevelType.value.find((it)=>it.value == item)
    return itemName?.label
  }
}
// 清單
const fetchData =async() =>{
  let reimbursementItemProps = reimbursementItem.value?reimbursementItem.value:null
  let locationProp = location.value?location.value:null
  try {
    const response = await $api('/tca/reimburseItem/get', {
      method: 'POST',
      body: {
        reimbursementItem:reimbursementItemProps,
        location:locationProp,
        page:page.value-1,
        size:size.value,
      },
    });
    totalData.value = response.totalElements
    tableItems.splice(0 , tableItems.length , ...response.content)
  } catch (error) {
    totalData.value = 0
    tableItems.splice(0 , tableItems.length )
    console.error('Error during fetch:', error);
  }
}
// 新增/修改
const save =async(body) =>{
  try {
    const response = await $api('/tca/reimburseItem/save', {
      method: 'POST',
      body: body,
    });
    if(response){
      fetchData()
      dialog.value = false
      popSwal('success','成功','')
    }else{
      dialog.value = false
      popSwal('error','失敗','')
    }
  } catch (error) {
    popSwal('error','請稍後再試',error.message || "請稍後再試")
    console.error('Error during fetch:', error);
  }
}
// 刪除
const deleteApi =async(body) =>{
  try {
    const response = await $api('/tca/reimburseItem/delete', {
      method: 'POST',
      body: body,
    });
    fetchData()
    selectTable.value=[]
  } catch (error) {
    popSwal('error','請稍後再試',error.message || "請稍後再試")
    console.error('Error during fetch:', error);
  }
}


// ---------------

const openDialog = async(type) => {
  dialogTitle.value = type === 'add' ? '新增核銷項目與分類' : '修改核銷項目與分類';
  dialog.value = true;
  dialogStatus.value=type
  if(dialogStatus.value==dialogAllStatus[1].value){
    const editItem = tableItems.filter((item)=>item.prikey==selectTable.value[0])
    setForm(...editItem)
  }else{
    clearForm()
  }
}
const clearForm = () =>{
  selectedOption.value = costOption[0].value
  form.prikey=''
  form.location=null
  form.reimbursementItem=null
  form.amountStart=""
  form.amountEnd=""
  form.categoryRemark=''
  form.amountLimit=0
  form.fieldA='X'
  form.fieldB='0.00'
  form.remark=''
}

const setForm = (data) =>{
  console.log(data)
  selectedOption.value = data.paymentMethod
  form.prikey=data.prikey
  form.location=data.location
  form.reimbursementItem=data.reimbursementItem
  form.amountStart=data.judgeLower
  form.amountEnd=data.judgeUpper
  form.categoryRemark=data.category
  form.amountLimit=data.amountLimit
  form.fieldA=data.fieldA
  form.fieldB=data.fieldB
  form.remark=data.remarks
}

const closeDialog = () => {
  dialog.value = false;
}

const getReimbursementItemName = (item) =>{
  let itemName = reimbursementItems.value.filter((it)=>it.value == item)
  return itemName[0].label
}

const saveData = () =>{
  let data ={
    prikey: form.prikey,
    location: form.location,
    reimbursementItem: form.reimbursementItem,
    category: form.categoryRemark?form.categoryRemark.trim():'',
    judgeUpper:  selectedOption.value==costOption[0].value?form.amountEnd:'0',
    judgeLower:  selectedOption.value==costOption[0].value?form.amountStart:'0',
    amountLimit: selectedOption.value==costOption[0].value?Number(form.amountLimit):0,
    paymentMethod: selectedOption.value,
    fieldB:form.fieldB, //日支數額比例
    remarks: form.remark,
  }
  return data
}

const saveBtn = async() => {
  const { valid } = await formRef.value.validate();
  if (valid) {
    // closeDialog();
      const data =await saveData()
    // if(dialogStatus.value==dialogAllStatus[0].value){
      // 新增
      save(data)
    // }else{
      // 修改
      // save(data)
    // }
  }
}
const deleteItem = () => {
  $swal({
    title: `刪除資料`,
    text: "",
    showCancelButton: true,
    confirmButtonText: "我要刪除",
    cancelButtonText: "取消",
  }).then(async(result) => {
    if (result.isConfirmed) {
      const data = tableItems.filter(it => selectTable.value.includes(it.prikey));
      deleteApi(data)
    }
  })
}


watch(size,()=>{
  fetchData()
})
watch(page,()=>{
  fetchData()
})
watch(reimbursementItem,()=>{
  fetchData()
})
watch(location,()=>{
  fetchData()
})

onMounted(()=>{
  fetchData()
})
</script>

<style scoped>
.elevation-1 {
  box-shadow: 0px 1px 3px rgba(0, 0, 0, 0.12), 0px 1px 2px rgba(0, 0, 0, 0.24);
}
</style>
